import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchAllConfiguration = createAsyncThunk('configurations/fetchAll',
    async ({config}, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.get(`${api.configuration.getAll}?config=${config??""}`);
            return response.data.data;
        } catch(error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

export const createConfiguration = createAsyncThunk('configurations/create',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.post(api.configuration.create, payload);
            if (response.data?.success === false) {
                return rejectWithValue(response.data.reason || "Failed to create configuration");
            }
            return response.data.data;
        }
        catch(error) {
            return rejectWithValue(error?.data?.reason || "Unable to connect to server");
        }
    }
)

export const deleteConfiguration = createAsyncThunk('configurations/delete',
    async (configId, { rejectWithValue }) => {
        try {
            const url = `${api.configuration.delete}/${configId}`;
            const response = await axiosPrivate.delete(url);
            if (response.data?.success === true) {
                return configId;
            } else {
                return rejectWithValue("Delete failed");
            }
        } catch(error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to delete configuration");
        }
    }
)

export const updateConfiguration = createAsyncThunk('configurations/update',
    async ({ configId, updatedData }, { rejectWithValue }) => {
        try {
            const url = `${api.configuration.update}/${configId}`;
            const response = await axiosPrivate.put(url, updatedData);
            if (response.data?.success === true) {
                return response.data.data;
            } else {
                return rejectWithValue("update failed");
            }
        } catch(error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to update configuration");
        }
    }
)

const getAllConfigurationListSlice = createSlice({
    name: "Configurations",
    initialState: {
        configurations: [],
        status: 'idle',
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builders) => {
        builders
            .addCase(fetchAllConfiguration.pending,
                (state) => {
                    state.status = 'loading';
                    state.loading = true;
                })
            .addCase(fetchAllConfiguration.fulfilled,
                (state, action) => {
                    state.status = 'succeeded';
                    state.configurations = action.payload;
                    state.loading = false;
                }
            )
            .addCase(fetchAllConfiguration.rejected,
                (state, action) => {
                    state.status = 'Failed';
                    state.error = action.payload;
                    state.loading = false;
                }
            )
            .addCase(createConfiguration.fulfilled,
                (state, action) => {
                    state.configurations.push(action.payload);
                }
            )
            .addCase(deleteConfiguration.fulfilled,
                (state, action) => {
                    state.configurations = state.configurations.filter((config) => config.id !== action.payload)
                }
            )
            .addCase(updateConfiguration.fulfilled,
                (state, action) => {
                    state.configurations = state.configurations.map((config) => config.id === action.payload.id ? action.payload : config)
                }
            )
    }
})

export default getAllConfigurationListSlice.reducer;